import React from "react"
import styled from "styled-components"
import * as Ct from "ldlj"
import { reportError } from "./datadogRum"

export interface ErrorBoundaryProps {
  children: React.ReactNode
}

interface ErrorBoundaryImplState {
  error: Error | null
  componentStack: string | null
}

class ErrorBoundaryImpl extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryImplState
> {
  state: ErrorBoundaryImplState = { error: null, componentStack: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ componentStack: info.componentStack })
    reportError(error, { componentStack: info.componentStack })
  }

  resetError = () => {
    this.setState({ error: null, componentStack: null })
  }

  render() {
    const { error, componentStack } = this.state

    if (error) {
      return (
        <ErrorPlaceholder>
          <div>Une erreur est survenue : </div>
          <div>{error.toString()}</div>
          <div>{componentStack}</div>
          <Ct.Button
            label="Recharger la page"
            onClick={() => {
              this.resetError()
            }}
          />
        </ErrorPlaceholder>
      )
    }

    return this.props.children
  }
}

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  if (!import.meta.env.VITE_REACT_APP_ENV) {
    return <>{children}</>
  }

  return <ErrorBoundaryImpl>{children}</ErrorBoundaryImpl>
}

export default ErrorBoundary

const ErrorPlaceholder = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
